module.exports = __webpack_public_path__ + "img/SFJ0067.e528f694.jpg";